import { TextFilterData } from '../dto/EntityRepository';
import { PerPage } from '../enum/EnumRepository';

export function buildTextListParams(
  aui: string,
  metaData: { page: number; size: PerPage; sortData: { sort: string; direction: 'ASC' | 'DESC' } },
  filter?: TextFilterData | {},
): URLSearchParams {
  const p = new URLSearchParams();

  p.set('aui', aui);
  p.set('page', String(metaData.page));
  p.set('size', String(metaData.size));
  p.set('sortBy', metaData.sortData.sort);
  p.set('direction', metaData.sortData.direction);

  const tagIds = filter && 'tagIds' in filter ? filter.tagIds : undefined;
  tagIds?.forEach((id) => p.append('tagIds', String(id)));

  return p;
};
